var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.730469,
    y: 0.401306,
    width: 64,
    height: 64,
    rx: 18.6182,
    fill: "#E8F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8076 48.6922V22.6268",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.291 48.6922H39.3237",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.584 19.2049L44.7539 16.1104",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7744 23.7128L30.622 20.4112",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8079 22.6268C34.0075 22.6268 34.98 21.6543 34.98 20.4546C34.98 19.255 34.0075 18.2825 32.8079 18.2825C31.6082 18.2825 30.6357 19.255 30.6357 20.4546C30.6357 21.6543 31.6082 22.6268 32.8079 22.6268Z",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4631 37.8316C28.4631 39.2718 27.891 40.653 26.8726 41.6714C25.8543 42.6898 24.473 43.2619 23.0328 43.2619C21.5926 43.2619 20.2114 42.6898 19.193 41.6714C18.1747 40.653 17.6025 39.2718 17.6025 37.8316H28.4631Z",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9778 22.7381L17.6025 33.4872",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0732 22.7091L28.463 33.4872",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.012 31.3152C48.012 32.7554 47.4399 34.1367 46.4215 35.155C45.4031 36.1734 44.0219 36.7455 42.5817 36.7455C41.1415 36.7455 39.7602 36.1734 38.7419 35.155C37.7235 34.1367 37.1514 32.7554 37.1514 31.3152H48.012Z",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1921 16.891L37.1514 26.9711",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0117 26.9709L42.8682 16.6895",
    stroke: "#00A3FA",
    strokeWidth: 1.74545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalIcon);
export default __webpack_public_path__ + "static/media/legal-icon.67221b82a47ddbdc1272cd299e01a9b9.svg";
export { ForwardRef as ReactComponent };